/**
 * @desc 仓库绩效报表导出
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.inoutStepRecord.warehousePerformanceExport.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inoutStepRecord/warehousePerformanceExport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
